// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* 各ステップは見出しの上に72pxの余白を持つ（StepContainer.module.css 参照）。\n   Figma（STEP2以降）はステップバーのラベル下端から見出しまで48pxのため、差分を詰める */\n.JobSeekerEdit-module__steps___jCq8O {\n  margin-top: -21px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"steps": "JobSeekerEdit-module__steps___jCq8O"
};
export default ___CSS_LOADER_EXPORT___;
